import script from "./TrendSituaion.vue?vue&type=script&setup=true&lang=js"
export * from "./TrendSituaion.vue?vue&type=script&setup=true&lang=js"

import "./TrendSituaion.vue?vue&type=style&index=0&id=515375b6&lang=scss"

const __exports__ = script;

export default __exports__